<template>
<svg class="cnm-icon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 22.8667C17.5228 22.8667 22 18.3895 22 12.8667C22 7.34385 17.5228 2.8667 12 2.8667C6.47715 2.8667 2 7.34385 2 12.8667C2 18.3895 6.47715 22.8667 12 22.8667Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.0101 16.864L12.0101 12.864" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.0101 8.86401H12.0001" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>